import axios from 'axios';
import space_router from './router'
import id_router from './router/id'
import { logoutAuth } from './auth/auth.js'
import i18n from './plugins/i18n'
import store from './store/index'

const space = window.location.host.split('.')[0];
const router = () => {
    let routes;
    if (space == 'id') {
        routes = id_router;
    } else {
        routes = space_router;
    }
    return routes;
};
export function initResponseInterceptor() {
    axios.interceptors.response.use(
        res => res,
        error => {
            if (error.response.status === 401 && window.$cookies.get("token") != null) {
                logoutAuth()
                window.location.href = process.env.VUE_APP_PROTOCOL + "://" + space + "." + process.env.VUE_APP_DOMAIN + "/login"
            }
            if (error.response.status === 429) {
                window.alert(i18n.tc("tooManyRequestsError", error.response.headers['retry-after'], { numberSeconds: error.response.headers['retry-after'] }));
                return new Promise(() => {});
            }
            if (error.response.status === 503) {
                router().push({ name: 'PageMaintenanceMode' })
            }
            if (error.response.data.errors[0].status == 403 && error.response.data.errors[0].detail == 'Space is locked') {
                store.dispatch("lockPlatform", 'trialExpired');
                return new Promise(() => {});
            }
            if (error.response.data.errors[0].status == 403 && error.response.data.errors[0].detail == 'Space is locked, because of non-payment.') {
                store.dispatch("lockPlatform", 'paymentFailed');
                return new Promise(() => {});
            }
            if (error.response.data.errors[0].status == 451 && error.response.data.errors[0].detail == 'The server is denying access to the resource as a consequence of a legal demand. You must to accept the GDPR to get access to this resource.') {
                store.dispatch("lockPlatform", 'notAcceptedTerms');
                return Promise.reject(error);
            }

            return Promise.reject(error);
        },
    );
}